export default __webpack_public_path__ + "static/media/aditionalContent.1a6225db.png";